// "Was Arlo with you?" — confirm outings detected from phone location.

import { Check, Footprints, X } from 'lucide-react';
import { confirmAutoWalk } from '../../data/actions.ts';
import { useEvents, useHousehold } from '../../data/hooks.ts';
import { formatMiles } from '../../domain/geo.ts';
import { formatDuration, formatTime } from '../../domain/time.ts';
import type { LogEvent } from '../../domain/types.ts';

export function usePendingWalks(): LogEvent<'walk'>[] {
  const events = useEvents();
  return events.filter((e): e is LogEvent<'walk'> => e.type === 'walk' && e.data.auto === 'pending' && e.end !== undefined && e.at > Date.now() - 2 * 86_400_000);
}

export function PendingWalks() {
  const pending = usePendingWalks();
  const household = useHousehold();
  if (!pending.length) return null;
  return (
    <ul className="pending-walks">
      {pending.slice(0, 3).map((w) => {
        const who = household.people.find((p) => p.id === w.by)?.name ?? 'Someone';
        return (
          <li key={w.id}>
            <Footprints aria-hidden />
            <span className="next-text">
              <strong>Was Arlo with {who}?</strong>
              <span className="muted">
                Out {formatTime(w.at)}–{formatTime(w.end!)} · {formatDuration(w.end! - w.at)}
                {w.data.distanceKm ? ` · ${formatMiles(w.data.distanceKm)}` : ''}
              </span>
            </span>
            <button type="button" className="pw-yes" onClick={() => confirmAutoWalk(w, true)} aria-label="Yes, Arlo was there">
              <Check aria-hidden /> Yes
            </button>
            <button type="button" className="pw-no" onClick={() => confirmAutoWalk(w, false)} aria-label="No">
              <X aria-hidden />
            </button>
          </li>
        );
      })}
    </ul>
  );
}
